import React, { useEffect, useMemo, useState } from "react";
import { FiGitMerge, FiX } from "react-icons/fi";

export default function CrmMergeModal({
  open,
  copy,
  items,
  getItemLabel,
  saving = false,
  error = "",
  onClose,
  onSubmit,
}) {
  const cleanItems = useMemo(() => (Array.isArray(items) ? items.filter(Boolean) : []), [items]);
  const [targetId, setTargetId] = useState("");

  useEffect(() => {
    if (!open) return;
    setTargetId(cleanItems[0]?.id ? String(cleanItems[0].id) : "");
  }, [cleanItems, open]);

  if (!open) return null;

  const target = cleanItems.find((item) => String(item.id) === String(targetId));
  const sources = cleanItems.filter((item) => String(item.id) !== String(targetId));
  const canSubmit = Boolean(target?.id) && sources.length > 0 && !saving;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!canSubmit) return;
    onSubmit?.({
      target_id: target.id,
      source_ids: sources.map((item) => item.id),
    });
  };

  return (
    <div className="crm-modalBackdrop" role="presentation">
      <form className="crm-modal crm-mergeModal" onSubmit={handleSubmit}>
        <div className="crm-modalHeader">
          <div>
            <h2>{copy.title}</h2>
            <span>{copy.subtitle(cleanItems.length)}</span>
          </div>
          <button type="button" className="crm-iconButton" onClick={onClose} aria-label={copy.cancel} disabled={saving}>
            <FiX aria-hidden="true" />
          </button>
        </div>

        {error ? <div className="crm-error">{error}</div> : null}

        <p className="crm-mergeHelp">{copy.help}</p>

        <div className="crm-mergeTargetList" role="radiogroup" aria-label={copy.targetLabel}>
          {cleanItems.map((item) => {
            const itemId = String(item.id);
            const checked = itemId === String(targetId);
            return (
              <label key={item.id} className={`crm-mergeTarget${checked ? " is-selected" : ""}`}>
                <input
                  type="radio"
                  name="crmMergeTarget"
                  value={itemId}
                  checked={checked}
                  onChange={() => setTargetId(itemId)}
                />
                <span>
                  <strong>{getItemLabel(item)}</strong>
                  <small>{copy.targetHint(item.id)}</small>
                </span>
              </label>
            );
          })}
        </div>

        <div className="crm-mergeSummary">
          <strong>{copy.finalRecord}</strong>
          <span>{target ? getItemLabel(target) : "-"}</span>
          <strong>{copy.absorbedRecords}</strong>
          <span>{sources.length ? sources.map(getItemLabel).join(", ") : "-"}</span>
        </div>

        <div className="crm-modalActions">
          <button type="button" className="crm-ghostButton" onClick={onClose} disabled={saving}>
            {copy.cancel}
          </button>
          <button type="submit" className="crm-primaryButton" disabled={!canSubmit}>
            <FiGitMerge aria-hidden="true" />
            <span>{saving ? copy.saving : copy.confirm}</span>
          </button>
        </div>
      </form>
    </div>
  );
}
